export const DEMO_RECORDS = {
    sponsors: {
        id: 'demo-mastercard-foundation',
        name: 'Mastercard Foundation', email: 'hello@mastercardfdn.org', phone: '+1 800 123 4567', focusArea: 'Technology & Education', financials: { totalFunding: 5000000 }, media: { logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Mastercard_2019_logo.svg/1200px-Mastercard_2019_logo.svg.png' }, status: 'Active',
        _type: 'sponsors'
    },
    scholarships: {
        id: 'demo-mastercard-2026-wit',
        name: '2026 Women In Tech Grant', sponsorId: 'demo-mastercard-foundation', financials: { valueUSD: 5000 }, requirements: { eligibility: 'Female students in ICT', deadline: '2026-12-31' }, status: 'Active',
        _type: 'scholarships'
    },
    partners: {
        id: 'demo-aws-academy',
        name: 'AWS Academy', email: 'academy@amazon.com', phone: '+1 800 000 0000', partnerType: 'Technology Partner', impact: { hardwareDonated: 0, softwareLicenses: 500 }, media: { logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg' }, status: 'Active',
        _type: 'partners'
    },
    institutions: {
        id: 'demo-uon-kenya',
        name: 'University of Nairobi', email: 'info@uonbi.ac.ke', phone: '+254 20 123456', institutionType: 'University', academic: { studentVolume: 1500, accreditationBody: 'CUE Kenya', graduationRate: 85 }, media: { logoUrl: 'https://upload.wikimedia.org/wikipedia/en/thumb/6/64/University_of_Nairobi_logo.png/220px-University_of_Nairobi_logo.png' }, status: 'Active',
        _type: 'institutions'
    },
    industries: {
        id: 'demo-safaricom-plc',
        name: 'Safaricom PLC', email: 'hr@safaricom.co.ke', phone: '+254 722 000000', industrySector: 'Fintech', placement: { historicalHires: 120, avgSalary: 75000, techStacks: 'React, Node, AWS' }, media: { logoUrl: 'https://upload.wikimedia.org/wikipedia/en/thumb/5/58/Safaricom_logo.svg/1200px-Safaricom_logo.svg.png' }, status: 'Active',
        _type: 'industries'
    },
    campuses: {
        id: 'demo-dis-nairobi-hub',
        name: 'DIS Nairobi Hub', location: 'Westlands, Nairobi', campusType: 'Urban Hub', capacity: 250, internetStatus: 'Fiber (1 Gbps)', facilities: { classrooms: 10, labs: 4, auditoriums: 1 }, media: { logoUrl: 'https://via.placeholder.com/150/8B1A2D/FFFFFF?text=DIS' }, status: 'Active',
        _type: 'campuses'
    },
    trainers: {
        id: 'demo-dr-jane-doe',
        name: 'Dr. Jane Doe', email: 'jane@dis.edu', phone: '+254 700 111222', trainerType: 'Lead Instructor', specializations: ['Cloud Computing', 'React', 'AI'], alumniStatus: 'DIS Alumnus', media: { photoUrl: 'https://randomuser.me/api/portraits/women/44.jpg' }, status: 'Active',
        _type: 'trainers'
    },
    students: {
        id: 'demo-alice-smith',
        firstName: 'Alice', lastName: 'Smith', email: 'alice.smith@example.com', phone: '+254 711 222333', nationalId: '12345678', dob: '2000-05-15', county: 'Nairobi', eduLevel: 'Undergraduate', institution: 'University of Nairobi', graduationYear: 2025, programCategory: 'Software Engineering', programName: 'Fullstack Web Development', cohort: 'Cohort A (2026)', 
        campusId: 'demo-dis-nairobi-hub', scholarshipId: 'demo-mastercard-2026-wit', sponsorId: 'demo-mastercard-foundation', industryId: 'demo-safaricom-plc', institutionId: 'demo-uon-kenya', partnerId: 'demo-aws-academy', trainerId: 'demo-dr-jane-doe', sponsorship: 'Fully Funded', applicationRef: 'APP-2026-001', status: 'Active',
        _type: 'students'
    }
};

export const getDemoDataForCollection = (collectionName) => {
    if (DEMO_RECORDS[collectionName]) {
        return [DEMO_RECORDS[collectionName]];
    }
    return [];
};
